import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { MasterService } from '../../../services/master.service';
import { StoreService } from '../../../services/store.service';
import * as words from '../../../services/language'

import { Stat } from 'src/app/models/stat.model';

@Component({
    selector: 'inventory-aging-chart',
    templateUrl: './inventory-aging-chart.component.html',
    styleUrls: ['./inventory-aging-chart.component.scss'],
    standalone: false
})
export class InventoryAgingChartComponent implements OnInit, OnChanges {

    /** Threshold to determine if the aging percent of the last thirty days is acceptable. */
    private AGING_PERCENT_SUCCESS: number = 0.70

    /** Threshold to determine if the aging percent of the last thirty days needs investigation. */
    private AGING_PERCENT_WARNING: number = 0.60
    
    // Currently selected language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // Word replacements for each language.
    @Input() words: Object = words.language

    /** */
    @Input() latest: Stat | null = null

    /** Percentage of inventory under 30 days on the lot. */
    protected percent: number = 0

    /** Options to send to the cahrt to determine how it will render. */
    protected options = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false,
                text: ''
            }
        }
    }

    /** */
    protected stats = null;
    
    // Indicates whether the data is currently loading.
    private loading: boolean = false

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService) { }

    ngOnInit() {
        
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }
        
        if (changes.latest) {
            this.construct()
        }
    }

    /**
     * Based on the latest stats construct the stat data for us in the chart.
     */
    private construct = () => {
        if (!this.latest) {
            return
        }

        this.percent = 0
        if (this.latest.inventory > 0) {
            this.percent = (this.latest.inventoryAge1to30 / this.latest.inventory)
        }

        this.stats = {
            labels: ['1 to 30', '31 to 60', '61 to 90', '91 and over'],
            datasets: [{
                axis: 'y',
                label: null,
                data: [
                    this.latest.inventoryAge1to30,
                    this.latest.inventoryAge31to60,
                    this.latest.inventoryAge61to90,
                    this.latest.inventoryAge91AndOver
                ],
                backgroundColor: [
                    'rgba(66, 191, 210, 0.4)',
                    'rgba(66, 191, 210, 0.6)',
                    'rgba(66, 191, 210, 0.8)',
                    'rgba(66, 191, 210, 1)'
                ],
                borderColor: [
                    'rgba(66, 191, 210, 0.2)',
                    'rgba(66, 191, 210, 0.4)',
                    'rgba(66, 191, 210, 0.6)',
                    'rgba(66, 191, 210, 0.8)'
                ],
                borderWidth: 1
            }]
        }
    }

    /**
     * Based on the current aging percent return a 
     * badge color to use for the percent display.
     */
    protected level = (): string => {
        if (!this.percent) {
            return 'secondary'
        }

        if (this.percent >= this.AGING_PERCENT_SUCCESS) {
            return 'success'
        }

        if (this.percent >= this.AGING_PERCENT_WARNING) {
            return 'warning'
        }

        return 'danger'
    }
}
